/* eslint-disable no-useless-escape */
export default {
  GRAVATAR_URL: 'https://www.gravatar.com/avatar/',
  ASSIGNEE_TYPE: {
    ME: 'me',
    UNASSIGNED: 'unassigned',
    ALL: 'all',
  },
  WHATSAPP_FORMATTER: {
    ITALIC_PATTERN: /(?<!\*)\*(?!\*)([^\*\s][^*]*[^\s*]|\S)\*(?!\*)/g,
    ITALIC_CHARACTER: '_',
    BOLD_PATTERN: /(?<!\*)\*\*(?!\*)\s*([^\*\s][^\*]*[^\s*]|\S)\s*\*\*(?!\*)/g,
    BOLD_CHARACTER: '*',
    ITALIC_BOLD_PATTERN: /(?<!\*)\*\*\*(?!\*)\s*([^\*\s][^\*]*[^\s*]|\S)\s*\*\*\*(?!\*)/g,
    ITALIC_BOLD_CHARACTER: '_*',
    ITALIC_BOLD_CHARACTER_REVERSE: '*_',
  },
  WHATSAPP_FORMATTER_REVERSE: {
    ITALIC_PATTERN: /(?<!\_)\_(?!\_)([^\_\s][^\_]*[^\s\_]|\_\S)(?<!\_)\_(?!\_)/g,
    ITALIC_CHARACTER: '*',
    BOLD_PATTERN: /(?<!\*)\*(?!\*)([^\*\s][^*]*[^\s*]|\S)\*(?!\*)/g,
    BOLD_CHARACTER: '**',
    ITALIC_BOLD_PATTERN: /(?<!\*)\_\*(?!\*)\s*([^\*\s][^\*]*[^\s*]|\S)\s*\_\*(?!\*)/g,
    ITALIC_BOLD_CHARACTER: '***',
  },
  STATUS_TYPE: {
    OPEN: 'open',
    RESOLVED: 'resolved',
    PENDING: 'pending',
    SNOOZED: 'snoozed',
    ALL: 'all',
  },
  CLASSIFICATION_TYPE: {
    ALL: 'all',
    NONE: 'none',
  },
  SORT_BY_TYPE: {
    LATEST: 'latest',
    CREATED_AT: 'sort_on_created_at',
    PRIORITY: 'sort_on_priority',
    CLASSIFICATION: 'sort_on_classification'
  },
  ARTICLE_STATUS_TYPES: {
    DRAFT: 0,
    PUBLISH: 1,
    ARCHIVE: 2,
  },
  LAYOUT_TYPES: {
    CONDENSED: 'condensed',
    EXPANDED: 'expanded',
  },
  DOCS_URL: '//www.chatwoot.com/docs/product/',
  TESTIMONIAL_URL: 'https://testimonials.cdn.chatwoot.com/content.json',
  SMALL_SCREEN_BREAKPOINT: 1024,
  AVAILABILITY_STATUS_KEYS: ['online', 'busy', 'offline'],
  ACCEPT_SVG_TYPE: 'image/png, image/jpeg, image/gif, image/svg+xml',
  TYPE_MEDIA: 'image/png, image/jpeg, image/gif,image/heic, image/heif',
  TYPE_CSV: 'text/csv;charset=utf-8;',
};
export const DEFAULT_REDIRECT_URL = '/app/';
